import { gql } from '@apollo/client/core';

export const BULK_UPDATE_STUDENTS = gql`
  mutation BulkUpdateStudents($input: BulkUpdateStudentsInput!) {
    bulkUpdateStudents(input: $input) {
      success
      message
      code
    }
  }
`;

export const DISABLE_STUDENTS = gql`
  mutation DisableStudents($input: DisableStudentsInput!) {
    disableStudents(input: $input) {
      success
      message
      code
    }
  }
`;

export const ENABLE_STUDENTS = gql`
  mutation EnableStudents($input: EnableStudentsInput!) {
    enableStudents(input: $input) {
      success
      message
      code
    }
  }
`;

export const UPDATE_STUDENT_STATUS = gql`
  mutation UpdateStudentStatus($input: UpdateStudentStatusInput!) {
    updateStudentStatus(input: $input) {
      success
      message
      code
    }
  }
`;

export const BULK_RESET_STUDENT_PASSWORDS = gql`
  mutation BulkResetStudentPasswords($input: BulkResetStudentPasswordsInput!) {
    bulkResetStudentPasswords(input: $input) {
      success
      message
      code
      reset_count
      failed_count
      results {
        student_id
        student_name
        success
        message
      }
    }
  }
`;

export const EXPORT_STUDENTS = gql`
  mutation ExportStudents($input: ExportStudentsInput!) {
    exportStudents(input: $input) {
      id
      type
      status
      progress
      file_name
      file_url
      file_size
      error_message
      expires_at
      created_at
      updated_at
    }
  }
`;

export const GET_STUDENT_DISABLEMENT_HISTORY = gql`
  query StudentDisablementHistory($student_id: ID!) {
    studentDisablementHistory(student_id: $student_id) {
      id
      student_id
      disabled_at
      disabled_reason
      enabled_at
      enabled_reason
      is_current
      created_at
      disabledByUser {
        id
        name
      }
      enabledByUser {
        id
        name
      }
    }
  }
`;

export const CHECK_STUDENT_ACCESS = gql`
  query CheckStudentAccess {
    checkStudentAccess {
      is_disabled
      reason
      disabled_at
    }
  }
`;

export const DEENROLL_STUDENTS = gql`
  mutation DeenrollStudents($input: DeenrollStudentsInput!) {
    deenrollStudents(input: $input) {
      success
      message
      code
    }
  }
`;

export const ENROLL_STUDENTS_IN_CALENDAR = gql`
  mutation EnrollStudentsInCalendar($input: EnrollStudentsInCalendarInput!) {
    enrollStudentsInCalendar(input: $input) {
      success
      message
      code
    }
  }
`;
